import { ADDRESS } from '../../../themeSetting';

export const PROFILE = `/profileInfo`;

export const ROUTES = Object.freeze({
  PERSONAL_INFO: `${PROFILE}/personal-info/`,
  CHARGING_WALLET: `${PROFILE}/wallet/`,
  WITHDRAWALS_ACCOUNT: `${PROFILE}/withdrawals-account`,
  ADDRESS: `${PROFILE}/address/`,
  ADDRESS_LIST: `${PROFILE}/addressList`,
  TICKET_LIST: `${PROFILE}/ticketList`,
  ORDER_MAIN: `${PROFILE}/orders/`,
  ORDER_DETAIL: `${PROFILE}/orders/detail/:orderId`,
  NEW_PASSWORD: `${PROFILE}/new-password`,
  SIGN_IN: `/login`,
  RESET_PASSWORD: '/reset-password',
  PASSWORD: '/password',
  OTP: '/otp',
  MARKET_PLACE: '/cart',
  WITHDRAWALS_LIST: `${PROFILE}/withdrawals-list`,
  SHIPPING: '/addressPage',
});
